import styled, { css } from 'styled-components'

import { BiddingButton, BiddingButtonProps } from '@nx/bidding-engine'

export const StyledBiddingContainer = styled.div`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colours.grey['45']};
    border-top: 1px solid ${theme.colours.grey['45']};
    display: grid;
    gap: 5px;
    margin: 15px 0;
    padding: 10px 0;
    position: relative;
  `}
`

export const StyledBiddingButton = styled(BiddingButton)<BiddingButtonProps>`
  ${({ variant }) => css`
    ${variant === 'compact'
      ? css`
          justify-content: start;
          margin-top: 10px;
        `
      : css`
          margin: 0;
        `}
  `}
`
